import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faFile,
  faFilePdf,
  faMagic,
  faSave,
  faTimes,
  faUpload,
  faCog,
  faEdit,
  faPlay,
  faHourglass,
  faLifeRing,
  faCalculator
} from '@fortawesome/free-solid-svg-icons'
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";

export default class DashboardMenu extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
    };
  }

  handleUploadClick = (e) => {
    this.uploadRef.click()
  }

  handleUploadTemplateClick = (e) => {
    if (!this.props.isTemplateModified || window.confirm("Are you sure you want to discard the current template?")) {
      this.uploadTemplateRef.click()
    }
  }

  handleSaveClick = (e) => {
    var a = document.createElement("a");
    var file = new Blob([JSON.stringify(this.props.template, null, 2)], { type: "application/json" });
    a.href = URL.createObjectURL(file);
    a.download = this.props.templateName || "template.json";
    a.click();
    this.props.setIsTemplateModified(false)
  }


  handleClickRunTemplate = () => {
    if (this.props.isCustomFile) {
      this.props.handleRunTemplate()
    }
    else {
      if (window.confirm("No PDF file is loaded for testing. Do you want to load PDF file now?")) {
        this.uploadRef.click()
      }
    }
  }

  renderTooltip = (name, id, props) => (
    <Tooltip id={id} {...props} className="tooltip-btn">
      {name}
    </Tooltip>
  );

  render() {
    return (
      <div className="input-group dashboard-menu pB-10">

{/*
IMPORTANT:
.dashboard-menu css style uses z-index: 1000; to make sure that all the styles are on top of the editor
*/}
        <div className="container-fluid">
          <div className="header-buttons">
            <div className="ta-left">


              {/*<div className="d-inline-block mR-10 mT-10" style={{ verticalAlign: 'middle' }}>*/}


              {/*  <Dropdown className="small" drop="down">*/}
              {/*    <OverlayTrigger   placement="top"*/}
              {/*                      delay={{ show: 250, hide: 400 }}*/}
              {/*                      overlay={(props) => this.renderTooltip("Templates Library", "template_library_id", props)}>*/}
              {/*    <Dropdown.Toggle variant="success" id="dropdown-basic" disabled={this.props.isRunningTemplate}>*/}
              {/*      <FontAwesomeIcon icon={faLifeRing} /> Templates Library &nbsp;*/}
              {/*    </Dropdown.Toggle>*/}
              {/*    </OverlayTrigger>*/}

              {/*    <Dropdown.Menu*/}
              {/*      className="dropdown-multicol"*/}
              {/*    >*/}
              {/*      <div className="dropdown-row">*/}
              {/*        {SampleTemplateOptions.map(option => (*/}
              {/*          <Dropdown.Item*/}
              {/*            onClick={e => this.handleClickLoadSample(option)}*/}
              {/*            key={option.label}>{option.label}*/}
              {/*          </Dropdown.Item>*/}
              {/*        ))}*/}
              {/*      </div>*/}

              {/*    </Dropdown.Menu>*/}
              {/*  </Dropdown>*/}
              {/*</div>*/}

              <OverlayTrigger   placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={(props) => this.renderTooltip("Create or Open Template..", "template_library_id", props)}>
                <button disabled={this.props.isRunningTemplate} className="btn btn-success mR-10 mT-10" data-toggle="tooltip" data-placement="bottom" title="Create or Open Template" onClick={this.props.handleOpenSampleTemplate}>
                  <FontAwesomeIcon icon={faFile} /> Create or Open Template
                </button>
              </OverlayTrigger>

              <OverlayTrigger   placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={(props) => this.renderTooltip("Load Source PDF or Image", "load_source_PDF_or_image_id", props)}>
              <button disabled={this.props.isRunningTemplate} className="btn btn-info mR-10 mT-10" data-toggle="tooltip" data-placement="bottom" title="Load test PDF document that you will use to test your template" onClick={this.handleUploadClick}>
                <FontAwesomeIcon icon={faFilePdf} /> Load Source PDF or Image
              </button>
              </OverlayTrigger>



              <OverlayTrigger   placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={(props) => this.renderTooltip("Load Template From File", "load_template_from_file_id", props)}>
              <button disabled={!this.props.fileUploaded || this.props.isRunningTemplate} className="btn btn-info mR-10 mT-10" data-toggle="tooltip" data-placement="bottom" title="Load template" onClick={this.handleUploadTemplateClick}>
                <FontAwesomeIcon icon={faUpload} /> Load Template From File
              </button>
              </OverlayTrigger>


              <OverlayTrigger   placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={(props) => this.renderTooltip("Load Template From Clipboard", "load_template_from_clipboard", props)}>
              <button disabled={!this.props.fileUploaded || this.props.isRunningTemplate} className="btn btn-info mR-10 mT-10" data-toggle="tooltip" data-placement="bottom" title="Load template" onClick={this.props.handleEditClick}>
                <FontAwesomeIcon icon={faUpload} /> Load Template From Clipboard
              </button>
              </OverlayTrigger>


              <OverlayTrigger   placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={(props) => this.renderTooltip("Export Template To File", "export_template_to_file", props)}>
              <button disabled={!this.props.fileUploaded || this.props.isRunningTemplate} className="btn btn-secondary mR-10 mT-10" data-toggle="tooltip" data-placement="bottom" title="Save template" onClick={this.handleSaveClick}>
                <FontAwesomeIcon icon={faSave} /> Export Template To File
              </button>
              </OverlayTrigger>


              <OverlayTrigger   placement="bottom"
                                delay={{ show: 250, hide: 400 }}

                                overlay={(props) => this.renderTooltip("Edit Raw Template code in JSON format", "edit_export_template_id", props)}>
              <button disabled={!this.props.fileUploaded || this.props.isRunningTemplate} className="btn btn-secondary mR-10 mT-10" data-toggle="tooltip" data-placement="bottom" title="Save template" onClick={this.props.handleEditClick}>
                <FontAwesomeIcon icon={faSave} /> Edit Raw Template
              </button>
              </OverlayTrigger>

              {/*
              <button disabled={!this.props.fileUploaded || this.props.isRunningTemplate} className="btn btn-outline-dark mR-10 mT-10" data-toggle="tooltip" data-placement="bottom" title="Manually edit source code of the template" onClick={this.props.handleEditClick}>
                <FontAwesomeIcon icon={faEdit} />
              </button>
*/}

              <OverlayTrigger   placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={(props) => this.renderTooltip("Run Template", "run_template_id", props)}>
              <button disabled={this.props.isRunningTemplate} className="btn btn-warning mR-10 mT-10" data-toggle="tooltip" data-placement="bottom" title="Run template" onClick={this.handleClickRunTemplate}>
                {this.props.isRunningTemplate ? <FontAwesomeIcon icon={faHourglass} /> : <FontAwesomeIcon icon={faPlay} />} Run Template
              </button>
              </OverlayTrigger>

            </div>

            <OverlayTrigger   placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={(props) => this.renderTooltip("Run Document Classifier in a new window", "document_classifier_id", props)}>
            <div className="external-buttons">

              <a href="/document-classifier" target="_blank" 
                disabled={this.props.isRunningTemplate} 
                className="mt-2 small" 
                data-toggle="tooltip" 
                data-placement="bottom"
                title="Document Classifier"
                onClick={this.props.resetTemplate}>
                  Open Document Classifier..
              </a>
            </div>
            </OverlayTrigger>
          </div>
        </div>


        <div className="custom-file hidden">
          <input ref={(ref) => this.uploadRef = ref} type="file" className="form-control" accept="application/pdf,image/jpeg,image/png" id="uploadPdf" onChange={(e) => this.props.handleFileUploaded(e.target.files)} />
          <label className="custom-file-label ta-left" htmlFor="uploadPdf">{this.props.fileName}</label>
        </div>

        <div className="custom-file hidden">
          <input ref={(ref) => this.uploadTemplateRef = ref} type="file" className="form-control" accept=".json,.yml" id="uploadTemplate" onChange={(e) => this.props.handleTemplateUploaded(e)} />
        </div>

      </div>

    );
  }
}
